import { useState, useEffect } from 'react';
import { Grid, CircularProgress, Stack, TextField, Tooltip, Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import AccordionMonitoraggioSoggettoTerzo from './components/AccordionMonitoraggioSoggettoTerzo';
import RiepilogoSoggettoTerzo from './components/RiepilogoSoggettoTerzo';
import Footer from '../UI/FooterMonitoraggio';
import { searchSoggettoTerzoByCf } from '../services/searchSoggettoTerzoByCf'; // Importa il servizio
import { validaNotificaMonitoraggio } from '../services/validaNotificaMonitoraggio';
import { scartaNotificaMonitoraggio } from '../services/scartaNotificaMonitoraggio';
import Header from '../UI/Header';

const DettaglioSoggettoTerzo = () => {
  const location = useLocation();
  const [listaMonitoraggi, setListaMonitoraggi] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorState, setErrorState] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await searchSoggettoTerzoByCf(location.state?.selectedRowData.codiceFiscale);
        setListaMonitoraggi(response);
      } catch (error) {
        console.error('Errore durante la chiamata searchByCf:', error);
        setErrorState(true); // Gestione dell'errore
      } finally {
        setLoading(false); // Termina il caricamento
      }
    };

    if (location.state?.selectedRowData.codiceFiscale) {
      fetchData(); // Chiama fetchData solo se c'è un codice fiscale
    }
  }, [location.state?.selectedRowData.codiceFiscale]);

  const handleValidaNotifica = async (idMonitoraggio, idNotifica, nota) => {
    await validaNotificaMonitoraggio(idNotifica, nota);
  };

  const handleScartaNotifica = async (idMonitoraggio, idNotifica, nota) => {
    await scartaNotificaMonitoraggio(idNotifica, nota);
  };

  return (
    <>
      <Header
        showHome
        showRichiesta={false}
        showMonitoraggio={true}
        showSoggettiTerzi={true}
        showAccountingMonitoraggio={false}
        idNodoPratica={location.state?.selectedRowData.idMonitoraggio}
        praticaProperties={location.state?.selectedRowData}
        header={
          <Box
            sx={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              width: '100%',
              display: 'flex',
            }}
          >
            <Box
              sx={{
                marginTop: "70px",
                marginBottom: '1rem',
                flexDirection: 'row',
                width: '100%',
                justifyContent: 'space-between',
                display: 'flex',
              }}
            >
              <Box
                sx={{
                  flexDirection: 'row',
                  width: '80%',
                  justifyContent: 'center',
                  gap: "10px",
                  display: 'flex',
                }}
              >
                <Tooltip title={location.state?.selectedRowData.codiceFiscale}>
                  <Box sx={{ flexDirection: 'row' }}>
                    <TextField
                      disabled
                      value={location.state?.selectedRowData.codiceFiscale}
                      id="standard-basic"
                      helperText="Codice Fiscale"
                      variant="standard"
                      sx={{ width: '95%' }}
                    />
                  </Box>
                </Tooltip>
                <Tooltip title={location.state?.selectedRowData.ndgClienteCollegato}>
                  <Box sx={{ flexDirection: 'row' }}>
                    <TextField
                      disabled
                      value={location.state?.selectedRowData.ndgClienteCollegato}
                      id="standard-basic"
                      helperText="NDG Cliente collegato"
                      variant="standard"
                      sx={{ width: '95%' }}
                    />
                  </Box>
                </Tooltip>
                <Tooltip title={location.state?.selectedRowData.saleDiRiferimento}>
                  <Box sx={{ flexDirection: 'row' }}>
                    <TextField
                      disabled
                      value={location.state?.selectedRowData.saleDiRiferimento}
                      id="standard-basic"
                      helperText="Sale di riferimento"
                      variant="standard"
                      sx={{ width: '95%' }}
                    />
                  </Box>
                </Tooltip>
                <Tooltip title={location.state?.selectedRowData.pivaClienteCollegato}>
                  <Box sx={{ flexDirection: 'row' }}>
                    <TextField
                      disabled
                      value={location.state?.selectedRowData.pivaClienteCollegato}
                      id="standard-basic"
                      helperText="PIVA Cliente collegato"
                      variant="standard"
                      sx={{ width: '95%' }}
                    />
                  </Box>
                </Tooltip>
              </Box>
            </Box>
          </Box>
        }
      />

      <Grid item container xs={12} direction="row" justifyItems="space-between" alignItems="flex-start" mt={3}>
        {loading && <CircularProgress />} { }
        {errorState && <p>Errore nel caricamento dei monitoraggi</p>} { }

        <Grid item xs={12} sx={{ marginLeft: '2vw', marginRight: '2vw', width: '96vw' }}>
          <Box sx={{ marginBottom: '2rem' }}>
            <RiepilogoSoggettoTerzo soggettoTerzo={location.state?.selectedRowData} />
          </Box>
          <Stack sx={{ alignItems: 'center' }} spacing={2}> { }
            {listaMonitoraggi.map((monitoraggio) => (
              <AccordionMonitoraggioSoggettoTerzo
                key={monitoraggio.id}
                dettaglioMonitoraggio={monitoraggio}
                onValida={handleValidaNotifica}
                onScarta={handleScartaNotifica}
              />
            ))}
          </Stack>
        </Grid>
        <Footer idNodoPratica={location.state?.selectedRowData.idMonitoraggio} />
      </Grid>
    </>
  );
};

export default DettaglioSoggettoTerzo
